import {
  PARAMETER_RANGES,
  STATUS_LABELS,
  AQI_SCALE_BANDS,
} from "../constants/smartRoomConstants";

/**
 * Resolve status label + color for a numeric parameter.
 * Ranges are configurable via PARAMETER_RANGES.
 */
export const getParameterStatus = (rangeKey, rawValue) => {
  const value = toNumber(rawValue);
  if (value == null || !rangeKey || !PARAMETER_RANGES[rangeKey]) {
    return {
      status: STATUS_LABELS.UNKNOWN,
      color: "#9E9E9E",
      progress: 0,
    };
  }

  const bands = PARAMETER_RANGES[rangeKey];
  const maxBound = bands[bands.length - 1]?.max || 100;
  let matched = bands[bands.length - 1];

  for (let i = 0; i < bands.length; i += 1) {
    if (value <= bands[i].max) {
      matched = bands[i];
      break;
    }
  }

  return {
    status: matched.status,
    color: matched.color,
    progress: Math.min(100, Math.max(0, (value / maxBound) * 100)),
  };
};

export const getAqiBand = (rawValue) => {
  const value = toNumber(rawValue);
  if (value == null) {
    return AQI_SCALE_BANDS[0];
  }
  return (
    AQI_SCALE_BANDS.find((band) => value >= band.min && value <= band.max) ||
    AQI_SCALE_BANDS[AQI_SCALE_BANDS.length - 1]
  );
};

/**
 * Rough AQI (IN-style) estimate from PM2.5 for outdoor comparison when AQI is not returned.
 */
export const estimateAqiFromPm25 = (pm25Raw) => {
  const c = toNumber(pm25Raw);
  if (c == null) return null;

  const breakpoints = [
    { cLo: 0, cHi: 30, iLo: 0, iHi: 50 },
    { cLo: 31, cHi: 60, iLo: 51, iHi: 100 },
    { cLo: 61, cHi: 90, iLo: 101, iHi: 200 },
    { cLo: 91, cHi: 120, iLo: 201, iHi: 300 },
    { cLo: 121, cHi: 250, iLo: 301, iHi: 400 },
    { cLo: 251, cHi: 500, iLo: 401, iHi: 500 },
  ];

  const bp =
    breakpoints.find((b) => c >= b.cLo && c <= b.cHi) ||
    breakpoints[breakpoints.length - 1];

  const aqi =
    ((bp.iHi - bp.iLo) / (bp.cHi - bp.cLo)) * (c - bp.cLo) + bp.iLo;
  return Math.round(aqi);
};

export const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const formatDisplayValue = (value, digits = 1) => {
  const n = toNumber(value);
  if (n == null) return "—";
  if (Number.isInteger(n)) return String(n);
  return n.toFixed(digits).replace(/\.0+$/, "").replace(/(\.\d*[1-9])0+$/, "$1");
};
